var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3963 23.5548L16 18.1585L10.6037 23.5548C10.0101 24.1484 9.03879 24.1484 8.44519 23.5548C7.8516 22.9612 7.8516 21.9899 8.44519 21.3963L13.8415 16L8.44519 10.6037C7.8516 10.0101 7.8516 9.03879 8.44519 8.44519C9.03879 7.8516 10.0101 7.8516 10.6037 8.44519L16 13.8415L21.3963 8.44519C21.9899 7.8516 22.9612 7.8516 23.5548 8.44519C24.1484 9.03879 24.1484 10.0101 23.5548 10.6037L18.1585 16L23.5548 21.3963C24.1484 21.9899 24.1484 22.9612 23.5548 23.5548C22.9612 24.1484 21.9899 24.1484 21.3963 23.5548Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/close-menu.3c5475a04fb5caf312a2baac4fc5f107.svg";
export { ForwardRef as ReactComponent };